import { type IMunicipality } from '../models/municipality.model';
import { VasttrafikGidHelper } from './vasttrafik-gid.helper';

export class MunicipalityHelper {
  public static updateQueryString(municipalities: IMunicipality[]): void {
    if (municipalities && municipalities.length > 0) {
      const query = `?m=${municipalities.map((m) => m.gid).join('&m=')}`;
      window.history.pushState({ path: window.location.origin }, '', query);
    } else {
      window.history.pushState({ path: window.location.origin }, '', window.location.href.split('?')[0]);
    }
  }

  public static parseQueryString(): string[] {
    const search = new URLSearchParams(window.location.search);
    const municipalityGids: string[] = [];
    search.forEach((value, key) => {
      if (key === 'm') {
        const gid = VasttrafikGidHelper.isMunicipalityGid(value) ? value : undefined;
        if (gid) {
          municipalityGids.push(gid);
        }
      }
    });

    if (municipalityGids.length === 0) {
      return [];
    }

    return municipalityGids;
  }
}
